import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-confirm-action-with-reviews',
  templateUrl: './confirm-action-with-reviews.component.html',
  styleUrl: './confirm-action-with-reviews.component.scss'
})
export class ConfirmActionWithReviewsComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmActionWithReviewsData,
    protected dialogRef: MatDialogRef<ConfirmActionWithReviewsComponent>
  ) {
  }

  closeDialog(isActionConfirmed: boolean): void {
    this.dialogRef.close(isActionConfirmed);
  }
}

export interface ConfirmActionWithReviewsData {
  title: string;
  description: string;
  actionButtonText: string;
  cancelButtonText: string;
}
